// extracted by mini-css-extract-plugin
export var iconContainer = "_bc-0";
export var metricCardsContainer = "_bc-1";